import _ from "lodash";
import {
  FETCH_UTTERANCE_CLUSTER_DATA,
  FETCH_UTTERANCE_DATA,
  FETCH_ANSWERS_FOR_UTTERANCE,
  SAVE_UTTERANCE_QUESTION_MATCH,
  SAVE_UTTERANCE_CLUSTER_QUESTION_MATCH,
  FETCH_DROPDOWN_ENTITIES,
  FETCH_DROPDOWN_INTENTS,
  SAVE_ENTITY_TYPE
} from "../actions/types";

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_UTTERANCE_CLUSTER_DATA:
      return {
        ...state,
        utteranceClusterData: action.payload.data,
        chatbotId: action.payload.chatbotId,
        code: action.payload.code,
        count: action.payload.count,
        msg: action.payload.message
      };
    case FETCH_UTTERANCE_DATA:
      return {
        ...state,
        utterances: action.payload.data,
        chatbotId: action.payload.chatbotId,
        code: action.payload.code,
        total: action.payload.total
      };
    case FETCH_ANSWERS_FOR_UTTERANCE:
      return {
        ...state,
        answers: action.payload
      };
    case SAVE_UTTERANCE_QUESTION_MATCH:
      return {
        ...state,
        saved: action.payload
      };
    case SAVE_ENTITY_TYPE:
      return {
        ...state,
        saved: action.payload
      };
    case SAVE_UTTERANCE_CLUSTER_QUESTION_MATCH:
      return {
        ...state,
        saved: action.payload
      };
    case FETCH_DROPDOWN_INTENTS:
      return {
        ...state, 
        dropdownIntents: action.payload
      };
    case FETCH_DROPDOWN_ENTITIES:
      return {
        ...state,
        dropdownEntities: action.payload
      };
    default:
      return state;
  }
}
